export default "\n<div #interna>\n    <img src=\"{{image}}\" alt=\"\">\n    </div>\n    ";